import styled from "@emotion/styled";

export default styled.div`
  .MuiOutlinedInput-root {
    font-size: 14px;
    border-radius: 10px;
    background: #f0f0f0;
    padding: 5px 10px;
    width: 220px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .react-datepicker__input-container {
    input {
      outline: none;
      width: 220px;
      border-radius: 10px;
      background: #f0f0f0;
      padding: 10px;
    }
  }
`;
